import { IAppState } from '../../redux';
import { EBetPositionErrorCode } from '../../redux/reducers';
import { selectMaximalBet, selectMinimalBet, selectStepBet } from '../auction';
import { selectBetPositionErrorCode } from './selectBetPositionErrorCode';

export function selectBetInputError(state: IAppState): string | null {
  const minimalBet = selectMinimalBet(state);
  const maximalBet = selectMaximalBet(state);
  const stepBet = selectStepBet(state);
  const errorCode = selectBetPositionErrorCode(state);

  switch (errorCode) {
    case EBetPositionErrorCode.minimalBetReached:
      return `Минимальная ставка ${minimalBet} ₽`;

    case EBetPositionErrorCode.maximalBetReached:
      return `Максимальная ставка ${maximalBet} ₽`;

    case EBetPositionErrorCode.betNotDivided:
      return `Ставка должна быть кратна ${stepBet} ₽`;

    default:
      return null;
  }
}
